import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreSettings } from './store';

export function ApiBaseSection() {
  const { t } = useTranslation();
  const apiBase = useStoreSettings(s => s.apiBase);
  const savedApiBase = useStoreSettings(s => s.savedApiBase);
  const apiBaseChecking = useStoreSettings(s => s.apiBaseChecking);
  const apiBaseSaved = useStoreSettings(s => s.apiBaseSaved);
  const apiBaseError = useStoreSettings(s => s.apiBaseError);
  const setApiBase = useStoreSettings(s => s.setApiBase);
  const setApiBaseError = useStoreSettings(s => s.setApiBaseError);
  const saveApiBase = useStoreSettings(s => s.saveApiBase);

  return (
    <>
      <h2 className="font-semibold text-gray-800">{t('storeSettings.apiBaseTitle')}</h2>
      <p className="text-sm text-gray-500">{t('storeSettings.apiBaseHint')}</p>

      <div className="flex gap-2">
        <input
          type="url"
          value={apiBase}
          onChange={e => { setApiBase(e.target.value); setApiBaseError(null); }}
          placeholder={t('storeSettings.apiBasePlaceholder')}
          className="flex-1 rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={saveApiBase}
          disabled={apiBaseChecking}
          className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {apiBaseChecking ? '…' : apiBaseSaved ? '✓' : t('common.save')}
        </button>
      </div>

      {apiBaseError && (
        <p className="text-xs text-red-500">
          {t(`storeSettings.${apiBaseError}`, { defaultValue: apiBaseError })}
        </p>
      )}
      {savedApiBase && (
        <p className="text-xs text-gray-400">
          {t('storeSettings.currentBase')}: <span className="font-mono">{savedApiBase}</span>
        </p>
      )}
    </>
  );
}
